export default __webpack_public_path__ + "38bbb8bd9024ef7c4fd51cb0cdbad206.webp";